<div
  class="sb-input-time sb-dt"
  [class.sb-dt--clearable]="showClear()"
  [class.sb-dt--interactive]="interactive()"
  [class.sb-dt--help-inside]="helpInside()"
  [class.sb-dt--open]="isOpen()"
  (keydown)="onKeydown($event)"
  (focusout)="onFocusOut($event)">
  <app-sb-date-time-field
    [mode]="mode()"
    [(state)]="fieldState"
    [fieldId]="inputId()"
    [nameId]="label() ? labelId() : ''"
    [name]="ariaLabel()"
    [describedBy]="describedByIds()"
    [keptHintId]="keptHintId()"
    [invalid]="invalid()"
    [disabled]="disabled()"
    [readonly]="readonly()"
    [zone]="timeZone()"
    [floatLabel]="!!placeholder()"
    [required]="required()"
    (edited)="onEdited($event)"
    (openRequested)="open($event)"></app-sb-date-time-field>
  @if (showPlaceholder()) {
  <span class="sb-dt__placeholder" aria-hidden="true">{{ placeholder() }}</span>
  }
  <label [id]="labelId()">
    {{ label() }}
    @if (required()) {
    <span class="red">*</span>
    }
    <ng-content></ng-content>
  </label>
  <span class="visually-hidden" [id]="hintId()">{{ hint() }}</span>
  <span class="visually-hidden" [id]="keptHintId()">{{ keptHint }}</span>
  @if (interactive()) {
  <span class="sb-dt__actions">
    @if (showClear()) {
    <button
      type="button"
      class="sb-input-clear sb-dt__clear"
      tabindex="-1"
      title="Clear"
      [attr.aria-label]="clearLabel()"
      (click)="clear()">
      &times;
    </button>
    }
    <button
      #triggerEl
      type="button"
      class="sb-dt__trigger"
      aria-haspopup="dialog"
      [attr.aria-label]="triggerLabel()"
      [attr.aria-expanded]="isOpen()"
      [attr.aria-controls]="isOpen() ? panelId() : null"
      (click)="onTriggerClick($event)">
      @if (mode() === 'time') {
      <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm.5-13H11v6l5.25 3.15.75-1.23-4.5-2.67z"/></svg>
      } @else {
      <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M19 4h-1V2h-2v2H8V2H6v2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 16H5V10h14v10zm0-12H5V6h14v2z"/></svg>
      }
    </button>
  </span>
  }
</div>

<ng-template #panelTpl>
  <app-sb-date-time-panel
    [mode]="mode()"
    [panelId]="panelId()"
    [label]="label() || ariaLabel()"
    [selectedDate]="parts().date"
    [time]="timeParts()"
    [fieldEdits]="fieldEdits()"
    [min]="minDay()"
    [max]="maxDay()"
    [zone]="timeZone()"
    [picks]="picks()"
    [showClear]="showClear()"
    [showToday]="quickPicks() === 'none' && mode() !== 'datetime'"
    [narrow]="narrow()"
    (mousedown)="onPanelMouseDown($event)"
    (focusout)="onFocusOut($event)"
    (dayChosen)="onDayChosen($event)"
    (timeChosen)="onTimeChosen($event)"
    (pickChosen)="onPickChosen($event)"
    (cleared)="clear()"
    (todayChosen)="onToday()"
    (done)="onDone()"
    (escaped)="onEscaped()"
    (tabbedOut)="onTabbedOut($event)">
  </app-sb-date-time-panel>
</ng-template>
